/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { action } from '@ember/object';
import { RelationshipArgs } from 'cio/components/campaigns/trigger/setup/condition-blocks/relationship/config';
import operators from 'cio/utils/operators';
import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';

interface ConditionBlockRelationshipArgs extends RelationshipArgs {
  isRequired: boolean;
  columnCount: number;
  openSidebarOnMountEmpty?: boolean;
  onSidebarClose?: (hasConditions: boolean) => unknown;
}

export default class ConditionBlockRelationship extends Component<ConditionBlockRelationshipArgs> {
  @service store!: DS.Store;

  get highlight() {
    return this.conditionCount === 0;
  }

  get conditions() {
    return this.args.relationshipAttributes ?? [];
  }

  get conditionCount() {
    return this.conditions.length;
  }

  #convertRelAttrConditionToDisplayedData(condition: SerializedLegacyAttributeFilter) {
    return {
      label: `${condition.field} ${operators.find(({ value }) => value === condition.operator)?.label ?? ''}`,
      value: condition.value ?? '',
      condition,
    };
  }

  get displayedConditions() {
    let maxConditionCountBeforeThreshold = this.args.maxConditionCountBeforeThreshold ?? 3;

    let sliceCount =
      this.conditionCount > maxConditionCountBeforeThreshold
        ? maxConditionCountBeforeThreshold - 1
        : this.conditionCount;

    return this.conditions
      .slice(0, sliceCount)
      .map((condition) => this.#convertRelAttrConditionToDisplayedData(condition));
  }

  get cutOffCount() {
    return Math.max(this.conditionCount - this.displayedConditions.length, 0);
  }

  @action
  onSidebarClose(sidebarWasVisible: boolean) {
    if (this.args.onSidebarClose != null && sidebarWasVisible === true && this.args.openSidebarOnMountEmpty === true) {
      this.args.onSidebarClose(!this.highlight);
    }
  }
}
